import { FC, memo, useCallback, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Routes } from "../../layout/Routes";
import { actions, fetchList } from "./slice";
import { AppDispatch, RootState } from "../../app/store";
import { ApiStatuses } from "../../app/types";
import { saveLastPathname } from "../auth";
import { AbilityContext } from "../casl";

const Inner: FC = memo(() => {
  return <Routes />;
});

const getSystemId = (pathname: string) => {
  const paramsArray = pathname.split("/");
  return Number(paramsArray[1]);
};

export const AppSystemContainer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const ability = useContext(AbilityContext);

  const location = useLocation();

  const status = useSelector((state: RootState) => {
    return state.systems.status;
  });

  const handleFetchSystems = useCallback(async () => {
    dispatch(fetchList(ability.can("get", "systems")));
  }, [dispatch, ability]);

  useEffect(() => {
    handleFetchSystems();
  }, [handleFetchSystems]);

  useEffect(() => {
    saveLastPathname(location.pathname);
    if (status !== ApiStatuses.success) return;
    const systemId = getSystemId(location.pathname);
    dispatch(actions.setSelectedSystem(systemId));
  }, [location.pathname, dispatch, status]);

  return <Inner />;
};
